import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import axios from 'axios';
import Loader from "react-js-loader";
import TMLSubNavbar from '../TMLSubNavbar/TMLSubNavbar';
import Navbar3 from '../../Navbars/Navbar3';
import { toast } from 'react-toastify';
import Select from "react-select";
const { REACT_APP_UPLOAD_DATA } = process.env;

const monthOrder = [
    'April', 'May', 'June', 'July', 'August', 'September',
    'October', 'November', 'December', 'January', 'February', 'March'
];

export default function TMLModelPerformance() {
    const indianStates = [
        "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa",
        "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala",
        "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland",
        "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
        "Uttar Pradesh", "Uttarakhand", "West Bengal", "Delhi", "Jammu and Kashmir",
        "Ladakh", "Puducherry", "Chandigarh", "Andaman and Nicobar Islands",
        "Dadra and Nagar Haveli and Daman and Diu", "Lakshadweep"
    ];
    const stateOptions = indianStates.map(state => ({ value: state, label: state }));
    const [fyList, setFylist] = useState([])
    const [selectedState, setSelectedState] = useState("");
    const [selectedFY, setSlecetdFY] = useState('');
    const [modelPerformanceData, setModelPerformanceData] = useState([])
    const [expandedDealers, setExpandedDealers] = useState({});
    const [selectedDealer, setSelectedDealer] = useState(null);
    const [showChartModal, setShowChartModal] = useState(false);

    // Flags
    const [isFetchingMPData, setIsFetchingMPData] = useState(false)

    const fetchFiscalYear = async () => {
        try {
            const response = await axios.get(`${REACT_APP_UPLOAD_DATA}/app/getFy`)
            setFylist(response.data.map((it) => { return { label: it, value: it } }))
        } catch (error) {
            if (error.response) {
                if (error.response.status === 400) {
                    toast.error(`Server Error : ${error.response.data.detail}`)
                }
                else {
                    toast.error(`Server Error : ${error.response.message}`)
                }
            }
            else {
                toast.error('Server is Down - Check after sometime')
            }
        }
    }
    const fetchModelPerformanceData = async () => {
        setIsFetchingMPData(true)
        try {
            const config = {
                method: "post",
                url: `${REACT_APP_UPLOAD_DATA}/app/getModelPerformance`,
                headers: {
                    Accept: "text/plain",
                    "Content-Type": "application/json",
                },
                data: {
                    'fy': selectedFY
                }
            };
            const response = await axios(config)
            if (response.status === 200) {
                console.log(response.data)
                setModelPerformanceData(response.data)
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 400) {
                    toast.error(`Server Error : ${error.response.data.detail}`)
                }
                else {
                    toast.error(`Server Error : ${error.response.message}`)
                }
            }
            else {
                toast.error('Server is Down - Check after sometime')
            }
        }
        finally {
            setIsFetchingMPData(false)
        }
    }
    const toggleDealer = (dealerCode) => {
        setExpandedDealers((prev) => ({
            ...prev,
            [dealerCode]: !prev[dealerCode]
        }));
    };

    const openChartModal = (dealer) => {
        setSelectedDealer(dealer);
        setShowChartModal(true);
    };

    const closeChartModal = () => {
        setShowChartModal(false);
        setSelectedDealer(null);
    };

    const monthOrderMap = {
        January: 10,
        February: 11,
        March: 12,
        April: 1,
        May: 2,
        June: 3,
        July: 4,
        August: 5,
        September: 6,
        October: 7,
        November: 8,
        December: 9,
    };


    useEffect(() => {
        fetchFiscalYear()
        setShowChartModal(false)
    }, [])

    useEffect(() => {

    }, [selectedState])


    useEffect(() => {
        if (selectedFY != '') {
            fetchModelPerformanceData()
            setShowChartModal(false)
            setExpandedDealers({})
        }
    }, [selectedFY])

    return (
        <>
            {showChartModal && selectedDealer && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <Chart
                                    type="line"
                                    height={350}
                                    series={[
                                        {
                                            name: 'Actual',
                                            data: [...selectedDealer.plotData]
                                                .sort(
                                                    (a, b) => monthOrderMap[a.month] - monthOrderMap[b.month]
                                                )
                                                .map((d) => d.actuals.toFixed(2)),
                                        },
                                        {
                                            name: 'Predicted',
                                            data: [...selectedDealer.plotData]
                                                .sort(
                                                    (a, b) => monthOrderMap[a.month] - monthOrderMap[b.month]
                                                )
                                                .map((d) => d.predicted.toFixed(2)),
                                        }
                                    ]}
                                    options={{
                                        title: {
                                            text: `Actual vs Predicted (Dealer Code - ${selectedDealer.dealerCode} - ${selectedDealer.dealerName})`,
                                            align: "center",
                                        },
                                        grid: {
                                            show: false,
                                        },
                                        chart: {
                                            id: 'Download',
                                            type: "line",
                                            toolbar: { show: false }
                                        },
                                        xaxis: {
                                            categories: [...selectedDealer.plotData]
                                                .sort((a, b) => monthOrderMap[a.month] - monthOrderMap[b.month])
                                                .map((d) => d.month),
                                            title: {
                                                text: `Month - ${selectedFY}`,
                                                style: {
                                                    color: "#FFC107",
                                                },
                                            },
                                            labels: {
                                                style: {
                                                    fontSize: "14px",
                                                },
                                                formatter: function (val) {
                                                    return val;
                                                },
                                            },
                                        },
                                        yaxis: {
                                            opposite: false,
                                            min: 0,
                                            axisBorder: {
                                                show: true,
                                            },
                                            title: { text: 'Leads' },
                                            labels: {
                                                style: {
                                                    fontSize: "14px",
                                                },
                                            },
                                        },
                                        stroke: {
                                            curve: 'smooth',
                                            width: 2
                                        },
                                        colors: ["#4CAF50", "#FFC107"],
                                        dataLabels: {
                                            enabled: true,
                                            style: {
                                                fontSize: 11,
                                            },
                                            formatter: function (val) {
                                                return val;
                                            },
                                        },
                                    }}
                                />
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={closeChartModal}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Navbar3 />
            <TMLSubNavbar />
            <div className='bgpages'>
                <section className='container-fluid py-3'
                >
                    <div className='px-2 text-secondary small'>{`Dashboard >> Model Performance`}</div>
                    <div className="px-2 py-3 mb-3 d-flex justify-content-between align-items-center shadow-sm rounded" style={{ backgroundColor: '#ffffff' }}>
                        <b className="greentheme m-0" style={{ fontSize: "1.25rem" }}>Model Performance</b>
                    </div>
                    {/* Filters */}
                    <div className="card px-4 py-4 shadow-sm z-3">
                        <div className="row gy-4">
                            {/* Select State */}
                            <div className="col-12 col-md-3">
                                <label className="form-label">
                                    Select State: <span className='text-danger'>*</span>
                                </label>
                                <Select
                                    options={stateOptions}
                                    value={stateOptions.find(option => option.value === selectedState)}
                                    onChange={option => {
                                        setSelectedState(option ? option.value : "");
                                        setSlecetdFY('');
                                        setModelPerformanceData([])
                                    }}
                                    classNamePrefix="select"
                                    placeholder="Type or select a state..."
                                    isClearable
                                    isDisabled={isFetchingMPData}
                                />
                            </div>

                            {/* Select Fiscal Year */}
                            <div className="col-12 col-md-3">
                                <label className="form-label">
                                    Select FY: <span className='text-danger'>*</span>
                                </label>
                                <Select
                                    options={fyList}
                                    value={selectedFY ? fyList.find(option => option.value === selectedFY) : null}
                                    onChange={option => {
                                        setSlecetdFY(option ? option.value : '')
                                    }}
                                    placeholder="Select Fiscal Year"
                                    classNamePrefix="select"
                                    isDisabled={selectedState === '' || isFetchingMPData}
                                />
                            </div>
                        </div>
                    </div>

                    <div
                        className="card px-4 py-4 shadow-sm z-2 mt-4"
                        style={{ width: '90%', maxWidth: '1200px', margin: '0 auto' }}
                    >
                        {isFetchingMPData ? (
                            <div
                                className="row d-flex justify-content-center align-items-center"
                                style={{ height: '15vh' }}
                            >
                                <Loader
                                    type="box-rectangular"
                                    bgColor="#0A4742"
                                    title="Fetching Results....."
                                    color="#0A4742"
                                    size={75}
                                />
                            </div>
                        ) : modelPerformanceData.length > 0 ? (
                            <div
                                className="accordion-body p-0 custom-scroll"
                                style={{ maxHeight: '500px', overflowY: 'auto' }}
                            >
                                <table className="table  table-sm mb-0 text-center align-middle"
                                    style={{ borderSpacing: '0 10px', borderCollapse: 'separate' }}
                                >
                                    <thead className="table-dark sticky-top z-2">
                                        <tr>
                                            <th style={{ width: '10%' }}>Sr.No.</th>
                                            <th style={{ width: '30%' }}>Dealer Code</th>
                                            <th style={{ width: '20%' }}>Mape of {selectedFY}</th>
                                            <th style={{ width: '20%' }}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {modelPerformanceData.map((dealer, index) => (
                                            <React.Fragment key={dealer.dealerCode}>
                                                {/* Dealer summary row */}
                                                <tr>
                                                    <td className="fw-bold align-middle text-center">
                                                        {index + 1}
                                                    </td>
                                                    <td className="fw-bold align-middle text-left">
                                                        {dealer.dealerCode} - {dealer.dealerName}
                                                    </td>
                                                    <td className="fw-bold align-middle text-center"
                                                        style={{
                                                            backgroundColor: (dealer.mapeData * 100).toFixed(2) > 15 ? 'red' : ((dealer.mapeData * 100).toFixed(2) > 10 && (dealer.mapeData * 100).toFixed(2) <= 15) ? 'orange' : 'green',
                                                            color: 'white'
                                                        }}
                                                    >
                                                        {(dealer.mapeData * 100).toFixed(2)}
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-center flex-column flex-sm-row gap-2">
                                                            <button
                                                                className="btn btn-secondary btn-sm"
                                                                onClick={() => openChartModal(dealer)}
                                                            >
                                                                Show Actual Vs Predicted Chart
                                                            </button>
                                                        </div>

                                                    </td>
                                                </tr>

                                                {/* Expanded Detail Table */}
                                                {/* {expandedDealers[dealer.dealerCode] && (
                                                    <tr>
                                                        <td colSpan={2}>
                                                            <div className="bg-light rounded border p-3 mt-2 mb-3 shadow-sm">
                                                                <table className="table table-bordered table-sm mb-0 text-center align-middle"
                                                                    style={{ borderSpacing: '0 10px', borderCollapse: 'separate' }}
                                                                >
                                                                    <thead className="table-dark">
                                                                        <tr>
                                                                            <th style={{ width: '50%' }}>Month</th>
                                                                            <th style={{ width: '50%' }}>MAPE</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {[...dealer.mapeData]
                                                                            .sort((a, b) => a.month_order - b.month_order)
                                                                            .map((mape) => (
                                                                                <tr key={`${dealer.dealerCode}-${mape.month}`}>
                                                                                    <td className="align-middle fs-6 fw-medium text-secondary">
                                                                                        {mape.month}
                                                                                    </td>
                                                                                    <td className="align-middle fs-6 fw-medium"
                                                                                        // style={{
                                                                                        //     backgroundColor: (mape.mape * 100).toFixed(2) > 15 ? 'red':'green',
                                                                                        //     color:'white'
                                                                                        // }}
                                                                                    >
                                                                                        {(mape.mape * 100).toFixed(2)}%
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )} */}

                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-center py-5 text-muted">
                                <b className='greentheme'>No Model performance data available.</b>
                            </div>
                        )}
                    </div>
                </section>
            </div>
        </>
    );
}